export const isProductAvailableForAddingToGiveaway = product => {
  return !!product.inStock;
};